'use strict';

var ConfigurationMarketClassFareDirective = function ConfigurationMarketClassFareDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/configuration-market-class-fare.html'),
    controller: 'ConfigurationMarketClassFareController',
    link: function link(scope) {
      scope.$on('configuration-market-class-fare-grid:saveChanges', scope.saveChanges);
      scope.$on('configuration-market-class-fare-grid:removeFromServer', scope.saveRemovedRows);
      scope.$on('configuration-market-class-fare-grid:export', scope.exportToCSV);
      scope.$watch('selectedView', scope.updateSearchPanel);
    }
  };
};
ConfigurationMarketClassFareDirective.$inject = [];
module.exports = ConfigurationMarketClassFareDirective;